<template>
  <v-container fluid style="padding-top: 0px;">
    <v-row>
      <v-container class="pb-0">
        <v-row align-content-sm="center">
          <v-col cols="12" md="4">
            <h2>
              Welcome to Mosaic ATM's Airport Viewer
            </h2>
            <p class="mt-5">
              Real-time situation awareness of aircraft operating at
              <router-link to="/airports">over 40 airports</router-link>
              in the United States.
            </p>
            <AirportAutocomplete
              v-if="$auth.isAuthenticated"
              :emit="true"
              label="Select Airport"
              @airportsLoaded="handleAirportsLoaded"
              @airportSelected="handleAirportSelection"
            />
            <HorizontalAd
              v-if="featureAvailable('adsHidden') === false"
              :mock="mockAds"
            />
          </v-col>
          <v-col cols="12" md="6">
            <div>
              <AirportAutocomplete
                v-if="!$auth.isAuthenticated"
                :emit="true"
                label="Select Airport"
                @airportsLoaded="handleAirportsLoaded"
                @airportSelected="handleAirportSelection"
              />

              <!-- SVG USA MAP -->
              <div id="airports-map" class="text-center d-none d-md-flex" />
            </div>
          </v-col>
          <v-col class="d-none d-md-flex" cols="2">
            <VerticalAd
              v-if="featureAvailable('adsHidden') === false"
              class="ml-5"
              :mock="mockAds"
            />
          </v-col>
        </v-row>

        <!--
        <h1 class="text-center my-12">What our customers say about us:</h1>
        <Testimonials class="my-12" />
        -->

        <v-row class="my-12">
          <v-col cols="12" class="text-center">
            <h1>Why Mosaic Airport Viewer?</h1>
          </v-col>
          <v-col cols="12" md="4">
            <h3>Real-time Situation Awareness</h3>
            <p>
              See where aircraft are taxiing and queued on the airport surface
              and which runways are in use, from a computer or mobile device
              without installing any software.
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <h3>Available Anywhere You Go</h3>
            <p>
              Cloud-based, Airport Viewer is accessible via popular web browsers
              on computers and mobile devices, as well as via the
              Android-compatible Airport Viewer App on Google’s PlayStore.
            </p>
          </v-col>
          <v-col cols="12" md="4">
            <h3>Scalable to Your Use Cases</h3>
            <p>
              Different subscription options scale Airport Viewer to meet
              various private and commercial use scenarios. Mosaic also offers
              an enterprise version – Mosaic Situation Viewer – with many
              additional features and the ability to add other airports.
            </p>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-12">
          <v-col cols="12">
            <v-img
              src="/desktop_mobile.png"
              class="ma-auto"
              :max-width="$vuetify.breakpoint.smAndDown ? '100%' : '65%'"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row
      style="background-color: rgba(220,220,220,.2); margin-bottom: -20px;"
    >
      <v-col cols="12">
        <PlansTable
          :internal="$auth.isAuthenticated"
          class="d-none d-md-block"
        />
        <PlansTableMobile :internal="$auth.isAuthenticated" class="d-md-none" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import AirportAutocomplete from '../components/landing/AirportAutocomplete'
import HorizontalAd from '../components/google/horizontalAd'
import VerticalAd from '../components/google/verticalAd'
import PlansTable from '../components/landing/PlansTable'
import PlansTableMobile from '../components/landing/PlansTableMobile'
// import Testimonials from '../components/landing/Testimonials'
import { EventBus, Events } from '../lib/Eventbus'
import UsesSelectAirportMixins from '../mixins/UsesSelectAirportMixins'
import UsesNotifications from '@/mixins/UsesNotifications'

export default {
  components: {
    PlansTable,
    PlansTableMobile,
    AirportAutocomplete,
    HorizontalAd,
    // Testimonials,
    VerticalAd
  },
  mixins: [UsesSelectAirportMixins, UsesNotifications],
  layout: 'landing',
  middleware: [
    'postSignup',
    'checkTermsOfService',
    'checkPrivacyPolicy',
    'checkSubscription'
  ],
  computed: {
    ...mapGetters({
      featureAvailable: 'user/featureAvailable',
      iataCode: 'settings/iataCode'
    }),
    mockAds() {
      return process.env.APP_ENV !== 'prod'
    }
  },
  created() {
    if (this.$store.getters['settings/isPWA']) {
      // this.$router.push('/pwa')
    }

    EventBus.$on(Events.airportSelected, () => {
      this.$router.push('/airport/' + this.iataCode)
    })
    EventBus.$on(Events.data.airportsLoaded, (res) => {
      this.handleAirportsLoaded(res)
    })
  },
  mounted() {
    this.showAppDeprecated()
  },
  beforeDestroy() {
    EventBus.$off(Events.airportSelected)
    EventBus.$off(Events.data.airportsLoaded)
  },
  methods: {
    ...mapMutations({
      setSelectedIata: 'settings/setSelectedIata'
    }),
    handleAirportSelection(val) {
      this.setSelectedIata(val)
      if (this.$auth.isAuthenticated) {
        this.$router.push('/airport/' + val)
      } else {
        EventBus.$emit(Events.navigation.openLoginDialog)
      }
    },
    handleAirportsLoaded(airports) {
      const self = this

      if (!this.$vuetify.breakpoint.xsOnly) {
        // TODO: MBH
        // Script is large (483kb) and only used for desktop.
        // Should we serve from CDN like this or ourselves?
        // Avoid requiring in webpack bundle if that increases
        // size for mobile devices even if not used.
        if (window.vega) {
          this.initAirportsMap(airports)
        } else {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.onload = function() {
            self.initAirportsMap(airports)
          }
          script.src = 'https://vega.github.io/vega/vega.min.js'
          document.head.appendChild(script)
        }
      }
    },
    initAirportsMap(airports) {
      const spec = {
        $schema: 'https://vega.github.io/schema/vega/v5.json',
        width: 600,
        height: 400,
        padding: { top: 20, left: 75, right: 75, bottom: 0 },
        autosize: 'none',
        signals: [
          {
            name: 'hover',
            value: null,
            on: [
              { events: '@cell:mouseover', update: 'datum' },
              { events: '@cell:mouseout', update: 'null' }
            ]
          },
          {
            name: 'iata_code',
            value: '',
            update: "hover ? hover.iata_code : ''"
          },
          {
            name: 'name',
            value: '',
            update: "hover ? hover.name : ''"
          },
          {
            name: 'tooltip_width',
            value: 75,
            update: 'name ? name.length * 5 > 75 ? name.length * 5 : 75 : 75'
          },
          {
            name: 'cell_stroke',
            value: null
          }
        ],

        data: [
          {
            name: 'states',
            url: '/vega/data/us-10m-states.json',
            format: { type: 'topojson', feature: 'states' },
            transform: [
              {
                type: 'geopath',
                projection: 'projection'
              }
            ]
          },
          {
            name: 'traffic',
            url: '/vega/data/flights-airport.csv',
            format: { type: 'csv', parse: 'auto' },
            transform: [
              {
                type: 'aggregate',
                groupby: ['origin'],
                fields: ['count'],
                ops: ['sum'],
                as: ['flights']
              }
            ]
          },
          {
            name: 'airports',
            values: airports,
            transform: [
              {
                type: 'lookup',
                from: 'traffic',
                key: 'origin',
                fields: ['iata_code'],
                as: ['traffic']
              },
              {
                type: 'geopoint',
                projection: 'projection',
                fields: ['longitude', 'latitude']
              },
              {
                type: 'filter',
                expr: 'datum.x != null && datum.y != null'
              },
              {
                type: 'voronoi',
                x: 'x',
                y: 'y'
              },
              {
                type: 'collect',
                sort: {
                  field: 'traffic.flights',
                  order: 'descending'
                }
              }
            ]
          }
        ],

        projections: [
          {
            name: 'projection',
            type: 'albersUsa',
            scale: 800,
            translate: [{ signal: 'width / 2' }, { signal: 'height / 2' }]
          }
        ],

        scales: [
          {
            name: 'size',
            type: 'linear',
            domain: { data: 'traffic', field: 'flights' },
            range: [6, 375]
          }
        ],

        marks: [
          {
            type: 'path',
            from: { data: 'states' },
            encode: {
              enter: {
                fill: { value: '#dedede' },
                stroke: { value: 'white' }
              },
              update: {
                path: { field: 'path' }
              }
            }
          },
          {
            type: 'symbol',
            from: { data: 'airports' },
            encode: {
              enter: {
                size: { scale: 'size', field: 'traffic.flights' },
                fill: { value: 'red' },
                fillOpacity: { value: 0.8 },
                stroke: { value: 'white' },
                strokeWidth: { value: 1.5 }
              },
              update: {
                x: { field: 'x' },
                y: { field: 'y' }
              }
            }
          },
          {
            type: 'path',
            name: 'cell',
            from: { data: 'airports' },
            encode: {
              enter: {
                fill: { value: 'transparent' },
                strokeWidth: { value: 0.35 }
              },
              update: {
                path: { field: 'path' },
                stroke: { signal: 'cell_stroke' }
              }
            }
          },
          {
            // tooltip group of marks
            type: 'group',
            encode: {
              enter: {
                height: { value: 40 },
                clip: { value: false },
                cornerRadius: { value: 10 },
                strokeForeground: { value: false },
                dy: { value: -25 },
                align: { value: 'center' }
              },
              update: {
                fill: { signal: "hover ? 'black' : ''" },
                fillOpacity: { signal: 'hover ? 0.7 : 0' },
                width: { signal: 'tooltip_width' },
                x: { signal: 'hover ? hover.x - tooltip_width / 2 : 0' },
                y: { signal: 'hover ? hover.y - 60 : 0' }
              }
            },
            marks: [
              {
                // airport code
                type: 'text',
                interactive: false,
                encode: {
                  enter: {
                    y: { value: 15 },
                    align: { value: 'center' },
                    fill: { value: 'white' },
                    fontSize: { value: 15 },
                    fontWeight: { value: 'bold' }
                  },
                  update: {
                    x: { signal: 'tooltip_width / 2' },
                    text: { signal: 'iata_code' }
                  }
                }
              },
              {
                // full airport name
                type: 'text',
                interactive: false,
                encode: {
                  enter: {
                    y: { value: 30 },
                    align: { value: 'center' },
                    fill: { value: 'white' },
                    fontSize: { value: 10 }
                  },
                  update: {
                    x: { signal: 'tooltip_width / 2' },
                    text: { signal: 'name' }
                  }
                }
              },
              {
                // little triangle on tooltip
                type: 'path',
                interactive: false,
                encode: {
                  enter: {
                    y: { value: 40 },
                    align: { value: 'center' },
                    path: { value: 'M0 0 H 15 L 7.5 7 Z' }
                  },
                  update: {
                    fill: { signal: "hover ? 'black' : ''" },
                    fillOpacity: { signal: 'hover ? 0.7 : 0' },
                    x: { signal: 'tooltip_width / 2 - 7.5' }
                  }
                }
              }
            ]
          }
        ]
      }

      const view = new window.vega.View(window.vega.parse(spec), {
        loader: window.vega.loader(),
        logLevel: window.vega.Warn,
        renderer: 'svg'
      })
        .initialize('#airports-map')
        .hover()
        .run()

      view.addEventListener('click', (event, item) => {
        this.setSelectedIata(item.datum.iata_code)
        if (this.$auth.isAuthenticated) {
          this.$router.push('/airport/' + item.datum.iata_code)
        } else {
          EventBus.$emit(Events.navigation.openLoginDialog)
        }
      })
    }
  }
}
</script>
